import Vue from 'vue'
import Router from 'vue-router'

import App from '../pages/App'
import Intro from '../pages/Intro'
import BasicInformation from '../pages/BasicInformation'
import Disclaimer from '../pages/Disclaimer'
import Symptoms from '../pages/Symptoms'
import SymptomDetails from '../pages/SymptomDetails'
import MedicalHistory from '../pages/MedicalHistory'
import PatientInformation from '../pages/PatientInformation'
import Summary from '../pages/Summary'
import SaveAndExport from '../pages/SaveAndExport'
import StatusNav from '../components/StatusNav'

import store from '../store/store'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  scrollBehavior (to, from, savedPosition) {
    if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; }
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/:lang/nettdoctor',
      component: App,
      children: [
        {
          path: '',
          name: 'Intro',
          component: Intro
        },
        {
          path: 'disclaimer',
          name: 'Disclaimer',
          component: Disclaimer
        },
        {
          path: 'basicinformation',
          name: 'BasicInformation',
          components: {default: BasicInformation, statusnav: StatusNav},
          props: {statusnav: { step: 1 }},
          beforeEnter: (to, from, next)  => {
            store.persistDisclaimer()
            if (!store.disclaimerAccepted) next(`/${to.params.lang}/nettdoctor/disclaimer`)
            else next()
          }
        },
        {
          path: 'symptoms',
          name: 'Symptoms',
          components: {default: Symptoms, statusnav: StatusNav},
          props: {statusnav: { step: 2 }},
          beforeEnter: (to, from, next)  => {
            store.persistDisclaimer()
            if (!store.disclaimerAccepted) next(`/${to.params.lang}/nettdoctor/disclaimer`)
            else next()
          }
        },
        {
          path: 'symptomdetails',
          name: 'SymptomDetails',
          components: {default: SymptomDetails, statusnav: StatusNav},
          props: {statusnav: { step: 3 }},
          beforeEnter: (to, from, next)  => {
            store.persistDisclaimer()
            if (!store.disclaimerAccepted) next(`/${to.params.lang}/nettdoctor/disclaimer`)
            else next()
          }
        },
        {
          path: 'patientinformation',
          name: 'PatientInformation',
          components: {default: PatientInformation, statusnav: StatusNav},
          props: {statusnav: { step: 4 }},
          beforeEnter: (to, from, next)  => {
            store.persistDisclaimer()
            if (!store.disclaimerAccepted) next(`/${to.params.lang}/nettdoctor/disclaimer`)
            else next()
          }
        },
        {
          path: 'medicalhistory',
          name: 'MedicalHistory',
          components: {default: MedicalHistory, statusnav: StatusNav},
          props: {statusnav: { step: 5 }},
          beforeEnter: (to, from, next)  => {
            store.persistDisclaimer()
            if (!store.disclaimerAccepted) next(`/${to.params.lang}/nettdoctor/disclaimer`)
            else next()
          }
        },
        {
          path: 'summary',
          name: 'Summary',
          components: {default: Summary, statusnav: StatusNav},
          props: {statusnav: { step: 6 }},
          beforeEnter: (to, from, next)  => {
            store.persistDisclaimer()
            if (!store.disclaimerAccepted) next(`/${to.params.lang}/nettdoctor/disclaimer`)
            else next()
          }
        },
        {
          path: 'saveandexport',
          name: 'SaveAndExport',
          component: SaveAndExport,
          beforeEnter: (to, from, next)  => {
            store.persistDisclaimer()
            if (!store.disclaimerAccepted) next(`/${to.params.lang}/nettdoctor/disclaimer`)
            else next()
          }
        },
        {
          path: 'print',
          name: 'Print',
          component: Summary,
          props: {
            printView: true
          }
        },
      ],
    }
  ]
})